import "../styles/Footer.css";

function Footer() {
    return (
        <section className="contact-us" id="contact">
            <div className="footer">
                <p>
                    ©2025 RSG Tüm hakları saklıdır.
                    <br/>

                </p>
                <div className="footer-img-div">
                   
                    <img
                        src="/Marmara_Universitesi_Logo.png"
                        alt="Marmara Üniversitesi Logo"
                        className="footer-logo"
                        loading="lazy"
                        decoding="async"
                        width="70"
                        height="auto"
                    />
                    <img
                        src="/JPG_Formatinda_YOK-Logo.jpg"
                        alt="YÖK Logo"
                        className="footer-logo"
                        loading="lazy"
                        decoding="async"
                        width="70"
                        height="auto"
                    />
                </div>
            </div>
        </section>
    );
}

export default Footer;
